export default class filterProjectsForm {
	private targetEl = document.querySelector('.filterProjectsForm__label');

	constructor() {

		if (!this.targetEl) {
			return;
		}

		this.targetEl.addEventListener('click', event => {
			this.targetEl.classList.toggle('active');
		});

		window.addEventListener('click', event => {
			if ((<HTMLElement>event.target).closest('.filterProjectsForm')) {
				return;
			}

			this.targetEl.classList.remove('active');
		});
	}

}
